import { z } from 'zod'
import { oc } from '@orpc/contract'
import { CONSENT_FIELD_KEYS, consentFieldsSchema } from './consent-sign.contract'

export const consentRectSchema = z.object({
  page: z.number(),
  x: z.number(),
  y: z.number(),
  width: z.number(),
  height: z.number(),
})

export const consentSignatureCellSchema = z.object({
  value: z.string().optional(),
  box: consentRectSchema.optional(),
})

export const consentFieldBoxSchema = z.object({
  parts: z.array(
    z.object({
      field: z.enum(CONSENT_FIELD_KEYS),
      value: z.string().optional(),
      required: z.boolean().optional(),
    }),
  ),
  page: z.number(),
  x: z.number(),
  y: z.number(),
  width: z.number(),
  height: z.number(),
})

export const consentPreview = oc
  .route({ method: 'POST', path: '/v2/consent/preview' })
  .input(
    z.object({
      patientId: z.string().optional(),
      organizationId: z.string(),
      fields: consentFieldsSchema.optional(),
    }),
  )
  .output(
    z.object({
      pdf: z.string(),
      missingFields: z.array(z.enum(CONSENT_FIELD_KEYS)),
      fieldBoxes: z.array(consentFieldBoxSchema),
      signatureCell: consentSignatureCellSchema.optional(),
    }),
  )
